module.exports = __webpack_public_path__ + "static/media/all-health-logo.9b03f8c1.svg";